import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import Select from "react-select";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const NewRange = () => {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    pools: [],
    carriers: [],
    carrierProtocols: [],
    onboardingStatuses: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      fetchWithToken("api/Pools"),
      fetchWithToken("api/Forms/RangeData"),
    ])
      .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
      .then(([data1, data2]) =>
        setFormData({
          pools: data1,
          carriers: data2.carriers,
          carrierProtocols: data2.carrierProtocols,
          callManagers: data2.callManagers,
          sessionManagers: data2.sessionManagers,
          onboardingStatuses: data2.onboardingStatuses,
          onboardingEngineers: data2.gtUsers,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <RangesForm data={formData} />
      )}
    </>
  );
};

const RangesForm = ({ data: formData }) => {
  const classes = useStyles();

  const pools = formData.pools;
  const carriers = formData.carriers;
  const carrierProtocols = formData.carrierProtocols;
  const onboardingStatuses = formData.onboardingStatuses;
  const callManagers = formData.callManagers;
  const sessionManagers = formData.sessionManagers;
  const users = formData.onboardingEngineers;

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });
  const [isIPTPool, setIsIPTPool] = useState(false);
  const [isContiguous, setIsContiguous] = useState(true);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [successFetch, setSuccessFetch] = useState(false);
  const [loading, setLoading] = useState(false);

  const [poolId, setPoolId] = useState(null);
  const [startNumber, setStartNumber] = useState(null);
  const [endNumber, setEndNumber] = useState(null);
  const [carrier, setCarrier] = useState(null);
  const [circuitID, setCircuitID] = useState(null);
  const [protocol, setProtocol] = useState(null);
  const [callManager, setCallManager] = useState(null);
  const [sessionManager, setSessionManager] = useState(null);
  const [onboardingEngineer, setOnboardingEngineer] = useState(null);
  const [serviceManager, setServiceManager] = useState(null);
  const [status, setStatus] = useState(null);
  const [onboardingDate, setOnboardingDate] = useState(null);
  const [offboardingDate, setOffboardingDate] = useState(null);

  let poolRef = useRef(null);
  let carrierRef = useRef(null);
  let protocolRef = useRef(null);
  let onBoardingRef = useRef(null);
  let callManagerRef = useRef(null);
  let sessionManagerRef = useRef(null);
  let sManagersRef = useRef(null);
  let statusRef = useRef(null);

  const [fileData, setFileData] = useState({});

  useEffect(() => {
    if (isIPTPool === false) {
      setIsContiguous(true);
      handleCancel();
    }
  }, [isIPTPool]);

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const getPools = () => {
    return pools.map((pool) => {
      return {
        value: pool.id,
        label: `${pool.name}`,
        ownerTech: pool.ownerTechnology,
      };
    });
  };

  const getUsers = () => {
    return users.map((user) => {
      return { value: user.gmid, label: `${user.firstName} ${user.lastName}` };
    });
  };

  const getCallManagers = () => {
    return callManagers.map((callManager) => {
      return { value: callManager.value, label: `${callManager.value}` };
    });
  };

  const getSessionManagers = () => {
    return sessionManagers.map((sessionManager) => {
      return { value: sessionManager.value, label: `${sessionManager.value}` };
    });
  };

  const getCarriers = () => {
    return carriers.map((carrier) => {
      return { value: carrier.id, label: `${carrier.name}` };
    });
  };

  const getCarrierProtocols = () => {
    return carrierProtocols.map((protocol) => {
      return { value: protocol.value, label: `${protocol.value}` };
    });
  };

  const getStatuses = () => {
    return onboardingStatuses.map((status) => {
      return { value: status.value, label: `${status.description}` };
    });
  };

  const fileChangeHandler = (event) => {
    handleCancel();
    clearAlert();

    var file = event.target.files[0];
    event.target.value = "";
    setSelectedFile(file);

    var reader = new FileReader();
    reader.onload = function (event) {
      var splitArray = event.target.result.split("\r\n");
      splitArray = splitArray.filter(Boolean);
      console.log("splitArray", splitArray);
      var numbersArray = [];
      for (const num of splitArray) {
        var numbers = /^[-+]?[0-9]+$/;
        if (num.match(numbers)) {
          if (numbersArray.includes(num)) {
            sendAlert(
              "Duplicate Numbers Found - Please Review File",
              "warning"
            );
            handleCancel();
            return;
          }
          numbersArray.push(num);
        } else {
          sendAlert(
            "Non-Numeric Numbers Found - Please Review File",
            "warning"
          );
          handleCancel();
          return;
        }
      }

      if (numbersArray.length <= 0)
        return sendAlert("No Content In File", "warning");

      var numbersObj = numbersArray.sort().map((num) => {
        return { did: num };
      });

      setFileData({
        phoneNumbers: numbersObj,
        totalCount: numbersArray.length,
        availableCount: numbersArray.length,
        startNumber: numbersObj[0].did,
        endNumber: numbersObj[numbersObj.length - 1].did,
      });
      setIsSelected(true);
    };
    reader.readAsText(file);
  };

  const handleCancel = (event) => {
    setIsSelected(false);
    setSelectedFile(null);
  };

  const mySubmitHandler = (e) => {
    e.preventDefault();

    let formData = {
      poolId: poolId,
      startNumber: startNumber,
      endNumber: endNumber,
      carrierId: carrier,
      carrierCircuitId: circuitID != "" ? circuitID : null,
      carrierProtocol: protocol,
      callManagerFqdn: callManager,
      smeTcLocation: sessionManager,
      onboardingEngineer: onboardingEngineer,
      serviceManager: serviceManager,
      onboardingStatus: status,
      onboardDate: onboardingDate,
      offboardDate: offboardingDate,
    };
    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (formData.poolId == null) stringArray.push("Pool");
    if (formData.startNumber == null) stringArray.push("Start Number");
    if (formData.endNumber == null) stringArray.push("End Number");
    if (formData.carrierId == null) stringArray.push("Carrier ID");
    if (formData.smeTcLocation == null) stringArray.push("Session Manager");
    if (formData.onboardingStatus == null)
      stringArray.push("Onboarding Status");

    if (
      formData.poolId == null ||
      formData.startNumber == null ||
      formData.endNumber == null ||
      formData.carrierId == null ||
      formData.smeTcLocation == null ||
      formData.onboardingStatus == null
    ) {
      stringArray.map((error, index) => {
        if (index === stringArray.length - 1)
          errorMesssage += index == 0 ? error : " & " + error;
        else errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    if (
      formData.startNumber.length < 9 ||
      formData.startNumber.length > 13 ||
      formData.endNumber.length < 9 ||
      formData.endNumber.length > 13
    ) {
      sendAlert("Numbers Must Be 9 To 13 Digits Long", "warning");
      return;
    }

    if (
      formData.startNumber.length < 9 ||
      formData.startNumber.length > 13 ||
      formData.endNumber.length < 9 ||
      formData.endNumber.length > 13
    ) {
      sendAlert("Numbers Must Be 9 To 13 Digits Long", "warning");
      return;
    }

    if (formData.startNumber < 0 || formData.endNumber < 0) {
      sendAlert("Negative Numbers Not Accepted.", "warning");
      return;
    }

    const count = formData.endNumber - formData.startNumber + 1;

    if (count > 1000) {
      sendAlert("Range Can Be No Longer Than 1000 Numbers", "warning");
      return;
    }

    formData.totalCount = count;
    formData.availableCount = count;

    setLoading(true);
    var successfulResponse = false;

    fetchWithToken(`api/Ranges/`, "POST", formData)
      .then((res) => {
        if (res.ok) successfulResponse = true;
        return res.json();
      })
      .then((data) => {
        if (successfulResponse) setSuccessFetch(true);
        setSuccessFetch(false);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
        console.log("Data Returned: ", data.returnObject);
      });
  };

  const handleNonConSubmit = (e) => {
    e.preventDefault();

    let formData = {
      poolId: poolId,
      startNumber: startNumber,
      endNumber: endNumber,
      carrierId: carrier,
      carrierCircuitId: circuitID != "" ? circuitID : null,
      carrierProtocol: protocol,
      callManagerFqdn: callManager,
      smeTcLocation: sessionManager,
      onboardingEngineer: onboardingEngineer,
      serviceManager: serviceManager,
      onboardingStatus: status,
      onboardDate: onboardingDate,
      offboardDate: offboardingDate,
      phoneNumbers: fileData.phoneNumbers,
      totalCount: fileData.totalCount,
      availableCount: fileData.availableCount,
      startNumber: fileData.startNumber,
      endNumber: fileData.endNumber,
    };

    if (!isSelected) return sendAlert("No File Selected", "warning");

    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (formData.poolId == null) stringArray.push("Pool");
    if (formData.carrierId == null) stringArray.push("Carrier ID");
    if (formData.smeTcLocation == null) stringArray.push("Session Manager");
    if (formData.onboardingStatus == null)
      stringArray.push("Onboarding Status");

    if (
      formData.poolId == null ||
      formData.carrierId == null ||
      formData.smeTcLocation == null ||
      formData.onboardingStatus == null
    ) {
      stringArray.map((error, index) => {
        if (index === stringArray.length - 1)
          errorMesssage += index == 0 ? error : " & " + error;
        else errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    if (
      formData.startNumber.length < 9 ||
      formData.startNumber.length > 13 ||
      formData.endNumber.length < 9 ||
      formData.endNumber.length > 13
    ) {
      return sendAlert("Numbers Must Be 9 To 13 Digits Long", "warning");
    }
    if (formData.startNumber < 0 || formData.endNumber < 0) {
      return sendAlert("Negative Numbers Not Accepted.", "warning");
    }

    setLoading(true);
    var successfulResponse = false;
    fetchWithToken(`api/Ranges/AddNonContiguous`, "POST", formData)
      .then((res) => {
        if (res.ok) successfulResponse = true;
        return res.json();
      })
      .then((data) => {
        if (successfulResponse) setSuccessFetch(true);
        setSuccessFetch(false);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
        console.log("Data Returned: ", data.returnObject);
      });
  };

  const clearContent = () => {
    setStartNumber("");
    setEndNumber("");
    setCircuitID("");
    setOnboardingDate("");
    setOffboardingDate("");
    callManagerRef.select.clearValue("");
    sessionManagerRef.select.clearValue("");
    statusRef.select.clearValue("");
    sManagersRef.select.clearValue("");
    poolRef.select.clearValue("");
    carrierRef.select.clearValue("");
    protocolRef.select.clearValue("");
    onBoardingRef.select.clearValue("");
  };

  useEffect(() => {
    if (successFetch) clearContent();
  }, [successFetch]);

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      poolRef = ref;
                    }}
                    name="poolRef"
                    placeholder="Select Pool *"
                    options={getPools()}
                    onChange={(selection) => {
                      clearAlert();
                      setPoolId(
                        selection && selection.value ? selection.value : null
                      );
                      setIsIPTPool(
                        selection && selection.value
                          ? selection.ownerTech === "IPT"
                          : false
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>
              {isIPTPool && (
                <>
                  <div class="mb-3 row">
                    <div
                      class="col-sm-3"
                      style={{ paddingTop: "14px", marginLeft: "10px" }}
                    >
                      <h6>Choose One:</h6>
                    </div>
                    <div class="col-sm-8">
                      <RadioGroup
                        row
                        name="row-radio-buttons-group"
                        defaultValue="contiguous"
                        onChange={(e) => {
                          clearAlert();
                          setIsContiguous(e.target.value === "contiguous");
                        }}
                      >
                        <FormControlLabel
                          default
                          value="contiguous"
                          control={<Radio color="primary" />}
                          label="Contiguous"
                        />
                        <FormControlLabel
                          value="nonContiguous"
                          control={<Radio color="primary" />}
                          label="Non-Contiguous"
                        />
                      </RadioGroup>
                    </div>
                  </div>
                </>
              )}
              {isContiguous && (
                <div class="mb-3 row">
                  <div class="col-sm-6">
                    <input
                      type="number"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="startNumber"
                      placeholder="Start Number *"
                      maxlength="13"
                      value={startNumber}
                      onChange={(e) => {
                        clearAlert();
                        setStartNumber(e.target.value);
                      }}
                    />
                  </div>
                  <div class="col-sm-6">
                    <input
                      type="number"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="endNumber"
                      placeholder="End Number *"
                      maxlength="13"
                      value={endNumber}
                      onChange={(e) => {
                        clearAlert();
                        setEndNumber(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      carrierRef = ref;
                    }}
                    name="carrierRef"
                    placeholder="Select Carrier *"
                    options={getCarriers()}
                    onChange={(selection) => {
                      clearAlert();
                      setCarrier(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <input
                    type="text"
                    style={{ fontSize: "1em" }}
                    class="form-control"
                    name="carrierCircuitId"
                    placeholder="Circuit Id"
                    maxlength="25"
                    value={circuitID}
                    onChange={(e) => {
                      clearAlert();
                      setCircuitID(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      protocolRef = ref;
                    }}
                    name="protocolRef"
                    isClearable={true}
                    placeholder="Select Protocol"
                    options={getCarrierProtocols()}
                    onChange={(selection) => {
                      clearAlert();
                      setProtocol(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      callManagerRef = ref;
                    }}
                    name="callManagerRef"
                    isClearable={true}
                    placeholder="Select Call Manager"
                    options={getCallManagers()}
                    onChange={(selection) => {
                      clearAlert();
                      setCallManager(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      sessionManagerRef = ref;
                    }}
                    name="sessionManagerRef"
                    isClearable={true}
                    placeholder="Select Session Manager *"
                    options={getSessionManagers()}
                    onChange={(selection) => {
                      clearAlert();
                      setSessionManager(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      onBoardingRef = ref;
                    }}
                    name="onBoardingRef"
                    isClearable={true}
                    placeholder="Select Onboarding Engineer"
                    options={getUsers()}
                    onChange={(selection) => {
                      clearAlert();
                      setOnboardingEngineer(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      sManagersRef = ref;
                    }}
                    name="sManagersRef"
                    isClearable={true}
                    placeholder="Select Service Manager"
                    options={getUsers()}
                    onChange={(selection) => {
                      clearAlert();
                      setServiceManager(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    ref={(ref) => {
                      statusRef = ref;
                    }}
                    name="statusRef"
                    placeholder="Select Status *"
                    options={getStatuses()}
                    onChange={(selection) => {
                      clearAlert();
                      setStatus(
                        selection && selection.value ? selection.value : null
                      );
                    }}
                    menuPortalTarget={document.querySelector("body")}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <div className="col-sm-6">
                  <div className="row align-items-center">
                    <label
                      htmlFor="onboardDate"
                      className="col-sm-5 col-form-label"
                      style={{ fontSize: "1em" }}
                    >
                      Onboard Date:
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="date"
                        className="form-control"
                        name="onboardDate"
                        value={onboardingDate}
                        onChange={(e) => {
                          clearAlert();
                          setOnboardingDate(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="row align-items-center">
                    <label
                      htmlFor="offboardDate"
                      className="col-sm-5 col-form-label"
                      style={{ fontSize: "1em" }}
                    >
                      Offboard Date:
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="date"
                        className="form-control"
                        name="offboardDate"
                        value={offboardingDate}
                        onChange={(e) => {
                          clearAlert();
                          setOffboardingDate(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {loading && (
                <>
                  <div style={{ margin: "25px" }}>
                    <span style={{ display: "table", margin: "0 auto" }}>
                      Please Wait For Process to Finish
                    </span>
                    <LinearProgress />
                  </div>
                </>
              )}
              {isIPTPool && !isContiguous ? (
                <div class="mb-3 row">
                  <div class="col-sm-8">
                    Upload File:{" "}
                    {isSelected && selectedFile && (
                      <>
                        {selectedFile.name} ({fileData.phoneNumbers.length}{" "}
                        Numbers)
                      </>
                    )}
                    <br />
                    <Button
                      className={classes.button}
                      variant="contained"
                      component="label"
                      color="primary"
                    >
                      Select File
                      <input
                        type="file"
                        name="file"
                        accept=".txt"
                        onChange={fileChangeHandler}
                        hidden
                      />
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      color="primary"
                      onClick={(e) => handleNonConSubmit(e)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              ) : (
                <Button
                  onClick={mySubmitHandler}
                  type="submit"
                  variant="contained"
                  className={classes.button}
                  color="primary"
                >
                  Submit
                </Button>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default NewRange;
